import {Component, Input, OnInit} from '@angular/core';
import {SelectorContainer} from '../../../core/selector-container';
import {SectionsContainer} from '../../../core/sections-container';
import {AConst} from '../../../core/a-const.enum';

@Component({
  selector: 'app-object-new-copy-view',
  templateUrl: './object-new-copy-view.component.html',
  styleUrls: ['./object-new-copy-view.component.scss']
})
export class ObjectNewCopyViewComponent implements OnInit {

  @Input() object;
  @Input() selectorContainer: SelectorContainer;
  @Input() sectionsContainer: SectionsContainer;

  AConst = AConst;

  constructor() {
  }

  ngOnInit() {
  }

}
